<ngb-datepicker #dp (select)="onDateSelection($event)"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [displayMonths]="2"
                [dayTemplate]="tsasasas" outsideDays="hidden">
</ngb-datepicker>

<ng-template #tsasasas let-date = date let-focused="focused" let-disabled="disabled">
  <span class="custom-day"
        [class.focused]="focused"
        [class.disabled]="disabled"
        [class.range]="isRange(date)"
        [class.borderLeft]="isBorderLeft(date)"
        [class.borderRight]="isBorderRight(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/core/achoo-datepicker-range/achoo-datepicker-range.component.html